import {useRouteError} from "react-router-dom";

export default function BubbleError(): never {
  // This just re-throws the error. This component is necessary because otherwise react-router renders
  // a crappy default error message instead of letting our own ErrorBoundary handle it.
  throw useRouteError();
}
